module.exports = __webpack_public_path__ + "img/i_main_my_tv.7e8200d0.svg";